export enum syncType {
  SET_SYNC_CLIENT_LISTENERS = 'SET_SYNC_CLIENT_LISTENERS',
  SYNC_CLIENT_ESTABLISHED = 'SYNC_CLIENT_ESTABLISHED',
  SYNC_CLIENT_DISCONNECTED = 'SYNC_CLIENT_DISCONNECTED',
  SYNC_CLIENT_CONNECTED = 'SYNC_CLIENT_CONNECTED',
  SYNC_CLIENT_CONNECTING = 'SYNC_CLIENT_CONNECTING',
  TOKEN_RENEWAL_ERROR = 'TOKEN_RENEWAL_ERROR',
  TOKEN_RENEWAL_SUCCESS = 'TOKEN_RENEWAL_SUCCESS'
}
